import moment from 'moment'

export const SOCIETE_DOUBLE_POINTS_TAKEOVER_ID = 'societe-double-points'

export const SOCIETE_DOUBLE_POINTS_START_DATE = moment('2025-12-04T00:00:00+1100')

// Regions where LuxPlus experiences discount is available (overrides double points banner)
export const EXPERIENCE_ENABLED_REGIONS = new Set([
  'AU', // Australia
  'US', // United States
  'GB', // United Kingdom
  'NZ', // New Zealand
  'SG', // Singapore
  'CA', // Canada
  'FR', // France
  'DE', // Germany
  'IE', // Ireland
  'IT', // Italy
  'NL', // Netherlands
  'SA', // Saudi Arabia
  'ZA', // South Africa
  'ES', // Spain
  'VN', // Vietnam
  'TH', // Thailand
  'AE', // United Arab Emirates
  'ID', // Indonesia
])
